import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transactionService from "./transactionService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";

export const fetchTransactions = createAsyncThunk(
  "transaction/fetchAll",
  async (params, thunkAPI) => {
    try {
      return await transactionService.getAll(params); // { data, summary }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });
    }
  }
);

const initialSummary = {
  total_revenue: 0, total: 0, success: 0, pending: 0, failed: 0, refunded: 0,
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState: {
    list: [],
    summary: initialSummary,
    isLoading: false,
    isError: false,
    message: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (s) => {
        s.isLoading = true; s.isError = false; s.message = "";
      })
      .addCase(fetchTransactions.fulfilled, (s, a) => {
        s.isLoading = false;
        s.list = a.payload.data || [];
        s.summary = a.payload.summary || initialSummary;
      })
      .addCase(fetchTransactions.rejected, (s, a) => {
        s.isLoading = false; s.isError = true;
        s.message = a.payload?.message || "Failed to load transactions";
      });
  },
});

export default transactionSlice.reducer;